export default __webpack_public_path__ + "59f50ce29e761d1b6df41185e24b91a8.svg";